import {
  US,
  ES,
  DE,
  FR,
  CN,
  VN,
  IT,
  CZ,
  DK,
  FI,
  JP,
  KR,
  NL,
  NO,
  PL,
  PT,
  BR,
  RO,
  SE,
  TH,
  TR,
} from "country-flag-icons/react/3x2";

export const allLangs = [
  {
    label: "English",
    value: "en",
    icon: <US style={{ width: 25, height: 25 }} />,
  },
  {
    label: "Spanish",
    value: "es",
    icon: <ES style={{ width: 25, height: 25 }} />,
  },
  {
    label: "German",
    value: "de",
    icon: <DE style={{ width: 25, height: 25 }} />,
  },
  {
    label: "French",
    value: "fr",
    icon: <FR style={{ width: 25, height: 25 }} />,
  },
  {
    label: "Chinese Simplified",
    value: "zh-CN",
    icon: <CN style={{ width: 25, height: 25 }} />,
  },
  {
    label: "Chinese Traditional",
    value: "zh-TW",
    icon: <CN style={{ width: 25, height: 25 }} />,
  },
  {
    label: "Vietnamese",
    value: "vi",
    icon: <VN style={{ width: 25, height: 25 }} />,
  },
  {
    label: "Italian",
    value: "it",
    icon: <IT style={{ width: 25, height: 25 }} />,
  },
  {
    label: "Czech",
    value: "cs",
    icon: <CZ style={{ width: 25, height: 25 }} />,
  },
  {
    label: "Danish",
    value: "da",
    icon: <DK style={{ width: 25, height: 25 }} />,
  },
  {
    label: "Finnish",
    value: "fi",
    icon: <FI style={{ width: 25, height: 25 }} />,
  },
  {
    label: "Japanese",
    value: "ja",
    icon: <JP style={{ width: 25, height: 25 }} />,
  },
  {
    label: "Korean",
    value: "ko",
    icon: <KR style={{ width: 25, height: 25 }} />,
  },
  {
    label: "Dutch",
    value: "nl",
    icon: <NL style={{ width: 25, height: 25 }} />,
  },
  {
    label: "Norwegian",
    value: "no",
    icon: <NO style={{ width: 25, height: 25 }} />,
  },
  {
    label: "Polish",
    value: "pl",
    icon: <PL style={{ width: 25, height: 25 }} />,
  },
  {
    label: "Portuguese",
    value: "pt-PT",
    icon: <PT style={{ width: 25, height: 25 }} />,
  },
  {
    label: "Portuguese (Brazil)",
    value: "pt-BR",
    icon: <BR style={{ width: 25, height: 25 }} />,
  },
  {
    label: "Romanian",
    value: "ro",
    icon: <RO style={{ width: 25, height: 25 }} />,
  },
  {
    label: "Swedish",
    value: "sv",
    icon: <SE style={{ width: 25, height: 25 }} />,
  },
  {
    label: "Thai",
    value: "th",
    icon: <TH style={{ width: 25, height: 25 }} />,
  },
  {
    label: "Turkish",
    value: "tr",
    icon: <TR style={{ width: 25, height: 25 }} />,
  },
];

export const defaultLang = allLangs[0]; // English
